/** Disable WebRTC before untrusted app code, including browser-prefixed constructors. */
export function disableWebRtc(target = globalThis) {
  for (const name of [
    'RTCPeerConnection',
    'RTCDataChannel',
    'RTCSessionDescription',
    'RTCIceCandidate',
  ]) {
    for (const prefix of ['', 'webkit', 'moz']) {
      Object.defineProperty(target, prefix + name, {
        value: undefined,
        writable: false,
        configurable: false,
      });
    }
  }
}

// The same self-contained implementation runs outside already-stored bundles.
// Sharing the script with the bundle makes guard failure stop app execution.
export const WEBRTC_BOOTSTRAP = `(${disableWebRtc.toString()})(globalThis);`;
